module.exports = __webpack_public_path__ + "img/arrow_top_2.87d4f92f.svg";